<template>
  <div>
    <div id="data-block-options-activation-summary" v-for="item in tariffOptions" :key="item.tariffOptionId">
      <b-row class="data-line opts">
        <b-col md="" sm="" class="data-cell first name">
          {{item.tariffOptionName}}
        </b-col>
        <b-col md="" sm="" class="data-cell second price">
          {{price(item.price)}}
        </b-col>
        <b-col md="" sm="" class="data-cell third runtime">
          {{item.duration.amount}} {{durationUnit(item.duration.unit)}}
        </b-col>
      </b-row>
      <b-row>
        <b-col md="" sm="" class="desc">
          {{item.info}}
        </b-col>
      </b-row>
    </div>
    <b-row class="data-line summe">
      <b-col md="" sm="" class="data-cell first">
        <slot name="txtSum">SUMME</slot>
      </b-col>
      <b-col md="" sm="" class="data-cell second">{{sum}}</b-col>
    </b-row>
  </div>
</template>
<script>
import durationUnit from '@/mixins/durationUnit'
import price from '@/mixins/price'

export default {
  name: 'TariffOptionsSummary',
  computed: {
    sum: function () {
      let sum = 0
      for (const item in this.tariffOptions) {
        sum += parseInt(this.tariffOptions[item].price)
      }
      return this.price(parseInt(sum))
    }
  },
  props: {
    tariffOptions: {
      type: Array,
      default: () => []
    }
  },
  mixins: [
    price,
    durationUnit
  ]
}
</script>
